export default {
  devicetype: 'school_web',
}
